import { createContext } from "react";

export const EditReservationContext = createContext(null);
